import _jsx from "@babel/runtime/helpers/jsx";
import PropTypes from 'prop-types';
import React, { forwardRef } from 'react';
import clsx from 'clsx';
import { Badge } from 'reaxl';
import UserIcon from '../UserIcon/index.js';

/**
 *  The HeaderBadgeTrigger is a presentational component that will render the user icon and text based on the logged in prop.
 *  It also displays
 *
 */
const HeaderBadgeTrigger = /*#__PURE__*/forwardRef((props, ref) => {
  const {
    isLoggedIn = false,
    profile = {},
    psxNotificationsCount,
    onTriggerMouseEnter = () => {},
    onToggle = () => {},
    className,
    ...rest
  } = props;
  const {
    firstName,
    name,
    thumbnailUrl
  } = profile;
  const wrapperProps = {
    className: 'display-flex link-unstyled',
    role: 'button',
    onClick: onToggle,
    onKeyUp: onToggle,
    onMouseEnter: onTriggerMouseEnter,
    key: 'headerBadgeUserIcon',
    // jsx-a11y/mouse-events-have-key-events
    // onMouseEnter must be accompanied by onFocus for accessibility (for keyboard-only users)
    onFocus: onTriggerMouseEnter,
    ref,
    tabIndex: 0
  };
  const showNotificationBadge = Boolean(psxNotificationsCount && parseInt(psxNotificationsCount, 10) > 0);
  if (!isLoggedIn) {
    wrapperProps['aria-label'] = 'Sign In';
  }
  const userIcon = /*#__PURE__*/React.createElement("span", Object.assign({
    "data-cmp": "userSignInTrigger",
    id: "userSignInCTA",
    className: clsx('header-badge-trigger display-flex align-items-center', className)
  }, rest), /*#__PURE__*/_jsx("span", {
    className: "text-link display-inline-block profile-label"
  }, void 0, isLoggedIn ? firstName || name || 'Profile' : 'Sign In'), /*#__PURE__*/_jsx("span", {
    className: "profile-icon"
  }, void 0, /*#__PURE__*/_jsx(UserIcon, {
    isLoggedIn: isLoggedIn,
    thumbnailUrl: thumbnailUrl
  }), showNotificationBadge && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/_jsx(Badge, {
    className: "text-size-200"
  }, void 0, parseInt(psxNotificationsCount, 10) >= 10 ? '9+' : psxNotificationsCount), "\xA0")));
  return /*#__PURE__*/React.createElement('span', wrapperProps, userIcon);
});
export default HeaderBadgeTrigger;